












import Vue from 'vue'
import Component from 'vue-class-component'

@Component<TopBanner>({
  props: {
    title: String,
    subtitle: String,
    description: String,
    image: String,
    useWave: Boolean
  }
})

export default class TopBanner extends Vue {
  /**
   * Props variables
   */
  title: string | undefined
  subtitle: string | undefined
  description: string | undefined
  image: string | undefined
  useWave: boolean | undefined

  /**
   * Component state variables
   */
  imageWave = require('@app/componentlib/src/assets/wavy-line-2.svg')

  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */

}
